/**
 * トリガータイプ
 */
export var TriggerType;

(function (TriggerType) {
  /**
   * 未選択
   */
  TriggerType[TriggerType["None"] = -1] = "None";
  /**
   * タップ
   */

  TriggerType[TriggerType["Tap"] = 0] = "Tap";
  /**
   * ゲイズ
   */

  TriggerType[TriggerType["Gaze"] = 1] = "Gaze";
  /**
   * プレイヤー
   */

  TriggerType[TriggerType["Player"] = 2] = "Player";
  /**
   * 近接
   */

  TriggerType[TriggerType["Proximity"] = 3] = "Proximity";
  /**
   * 自動
   */

  TriggerType[TriggerType["Auto"] = 4] = "Auto";
  /**
   * ハンド
   */

  TriggerType[TriggerType["Hand"] = 5] = "Hand";
  /**
   * データ
   */

  TriggerType[TriggerType["Data"] = 6] = "Data";
  /**
   * 待機
   */

  TriggerType[TriggerType["Wait"] = 7] = "Wait";
})(TriggerType || (TriggerType = {}));